import UserService from '../services/UserService';
import OrgService from '../services/OrgService';
import Common from './common';
import LoginService from '../../../services/login.service';
import Vue from 'vue';
import _ from 'lodash';
import createActivityDetector from 'activity-detector';

const state = {
    userInfo: null,
    organizations: [],
    orgContext: null,
    users: [],
    orgSelectionLock: false,
    allRoles: [],
    currentUserRoles: [],
    userPrivilegesAndCustomRoles: [],
    appconfigs: [],
    ccoOrg: null,
    ccoUsers: [],
    orgContextTimezone: null,
    justLoggedIn: false,
    modulesDictionary: null,
    pagination: {stored: true, rowsPerPage: 10,sortBy: ["updatedDate"],descending: true, page: 1, totalItems: 0}
};

const getters = {
    roles: state => {
        const roleItems = _.has(state, 'userInfo.roles') ? state.userInfo.roles : [];
        return roleItems;
    },
    isSU: state => {
        const roles = getters.roles(state);
        return roles.includes('su') || roles.includes('suPro'); // || roles.includes('suOrgMgr')
    },
    isSUPro: state => {
        const roles = getters.roles(state)
        return roles.includes('suPro')
    },
    isAdmin: state => {
        const roles = getters.roles(state)
        return roles.includes('admin')
    },
    isProfessional: state => {
        const roles = getters.roles(state)
        return roles.includes('pro') || roles.includes('professional')
    },
    getLoginName: state => {
        if (state.userInfo === null) {
            return null;
        }
        return state.userInfo.login
    },
    getName: state => {
        if (state.userInfo === null) {
            return null;
        }
        return state.userInfo.name;
    },
    getEmail: state => {
        if (state.userInfo === null) {
          return null;
        }
        return state.userInfo.email
    },
    getUsername: state => {
      if (state.userInfo === null) {
        return null;
      }
      return state.userInfo.username
    },
    getUserInfo: state => {
        if (state.userInfo === null) {
            return null;
        }
        return state.userInfo;
    },
    getUserId: state => {
        if (state.userInfo === null || !state.userInfo.hasOwnProperty('userId')) {
            return null;
        }
        return state.userInfo.userId
    },
    getOrgId: state => {
        if (state.userInfo === null || state.userInfo.orgId === null) {
            return null;
        }
        return state.userInfo.orgId;
    },
    getOrgTimezone: state => {
        if (state.orgContextTimezone) {
            return state.orgContextTimezone;
        }
        if (state.userInfo === null || state.userInfo.timezoneId === null) {
            return null;
        }
        return state.userInfo.timezoneId;
    },
    getOrgDomain: state => {
        if (!state.userInfo || !state.userInfo.orgDomain) {
            return null;
        }
        return state.userInfo.orgDomain;
    },
    getOrgName: state => {
        if (!state.userInfo || !state.userInfo.orgName) {
            return null;
        }
        return state.userInfo.orgName;
    },
    isG2: state => {
        return state.userInfo.farmG2;
    },
    userHasRole: state => role => {
        const roles = getters.roles(state);
        return roles.includes(role);
    },
    getOrganizationsTextValue: state => {
        return _.map(state.organizations, item => { return {text: item.id + ' - ' + item.name, value: item.id}});
    },
    getOrganizations: state => {
        return state.organizations;
    },
    getOrgContext: state => {
        return state.orgContext;
    },
    getOrgContextName: state => {
        if ((state.orgContext === null) || (state.orgContext <= 0)) {
            return null;
        }
        const contextOrg = _.find(state.organizations, {id: state.orgContext})
        if (!contextOrg) {
            return null;
        }
        return contextOrg.name;
    },
    activeUsers: state => { return state.users },
    adminUsers: state => { return _.filter(state.users, (user) => { return !!_.find(user.roles, {code: 'admin'})}) },
    getOrgSelectionLock: state => { return state.orgSelectionLock },
    getUserPrivilegesAndCustomRoles: state => { return state.userPrivilegesAndCustomRoles },
    getAppConfigs: state => { return state.appconfigs },
    getCcoTimezone: state => {
        if (state.ccoOrg === null) {
            return null;
        }
        return state.ccoOrg.timeZone;
    },
    getCollectionAgents: state => { return _.map(_.filter(state.users, (user) => { return !!user.collectionAgent }),
            (user) => { return { id: user.id, login: user.name + ' (' + user.login + ')'} } ) },
    getCcoUsers: state => { return _.map(state.ccoUsers, (user) => { return { id: user.id, login: user.name + ' (' + user.login + ')'} } ) },
    findUser: state => userId => {
        let retUser = null
        if (state.users) {
            retUser = _.find(state.users, {id: userId});
        }
        if (retUser) {
            return retUser;
        }
        if (state.ccoUsers) {
            retUser = _.find(state.ccoUsers, {id: userId});
        }
        return retUser;
    },
    justLoggedIn(state) { return state.justLoggedIn },
    getModulesDictionary(state) { return state.modulesDictionary },
    getPagination: (state) => {
        return state.pagination;
    }
};

const mutations = {
    initialize(state) {
        Vue.set(state, 'users', [])
    },
    logout(state) {
        let realmId = window.Config.keycloakDefaultRealm;
        if (state.dataProvider) {
          state.dataProvider.signOut(true);
        }

        Vue.set(state, 'pagination', {stored: true, rowsPerPage: 10,sortBy: ["updatedDate"],descending: true, page: 1, totalItems: 0});
        Vue.set(state, 'justLoggedIn', false);
        Vue.set(state, 'userInfo', null);
        Vue.set(state, 'dataProvider', null);
        Vue.set(state, 'organizations', []);

        Vue.set(state, 'orgContext', null);
        Vue.set(state, 'orgContextTimezone',null);
        Vue.set(state, 'currentUserRoles', []);
        Vue.set(state, 'userPrivilegesAndCustomRoles', []);
        Vue.set(state, 'orgSelectionLock', false);

        Vue.set(state, 'appconfigs', []);

        Vue.set(state, 'ccoOrg', null);
        Vue.set(state, 'ccoUsers', []);
        Vue.set(state, 'modulesDictionary', null);

        sessionStorage.removeItem("vuex");

        LoginService.logout();
    },
    setPagination(state, pagination) {
        Vue.set(state, 'pagination', pagination);
    },
    setDataProvider(state, dataProvider) {
        Vue.set(state, 'dataProvider', dataProvider);
    },
    setUserInfo(state, userInfo) {
        Vue.set(state, 'userInfo', userInfo);
    },
    setOrganizations(state, organizations) {
        Vue.set(state, 'organizations', organizations);
    },
    setUsers(state, users) {
        Vue.set(state, 'users', users);
    },
    setOrgContext(state, orgId) {
        Vue.set(state, 'orgContext', orgId)
    },
    setOrgSelectionLock(state, orgSelectionLock) {
        Vue.set(state, 'orgSelectionLock', orgSelectionLock);
    },
    setAllRoles(state, allRoles) {
        Vue.set(state, 'allRoles', allRoles);
    },
    setCurrentUserRoles(state, currentUserRoles) {
        Vue.set(state, 'currentUserRoles', currentUserRoles);
    },
    setUserPrivilegesAndCustomRoles(state, userPrivilegesAndCustomRoles) {
        Vue.set(state, 'userPrivilegesAndCustomRoles', userPrivilegesAndCustomRoles);
    },
    setAppConfigs(state, appconfigs) {
        Vue.set(state, 'appconfigs', appconfigs);
    },
    updateAppConfig(state, appConfig) {
        let i = _.findIndex(state.appconfigs, (cfg) => { return cfg.parameter.key === appConfig.parameter.key});
        if (i >= 0) {
            Vue.set(state.appconfigs, i, appConfig);
        }
    },
    setCcoOrg(state, ccoOrg) {
        Vue.set(state, 'ccoOrg', ccoOrg);
    },
    setCcoUsers(state, ccoUsers) {
        Vue.set(state, 'ccoUsers', ccoUsers);
    },
    setOrgContextTimezone(state, timeZone) {
        Vue.set(state, 'orgContextTimezone', timeZone);
    },
    setJustLoggedIn(state, value) {
        Vue.set(state, 'justLoggedIn', value);
    },
    setModulesDictionary(state, value) {
        Vue.set(state, 'modulesDictionary', value);
    }
};

const actions = {
    async logout({commit, dispatch}) {
        dispatch('status/setStatus', {inProgress: false, operation: "Logout", success: true, logAction: 'logout'}, {root: true})

        commit('initialize')
        commit('logout')
        dispatch('systems/initialize', '', {root: true})
        dispatch('endpoints/initialize', '', {root: true})
        dispatch('status/initialize', '', {root: true})
        dispatch('collectors/initialize', '', {root: true})
        commit('menus/initialize', '', {root: true})
    },
    initialize({commit, dispatch}) {
        commit('initialize')
    },
    setPagination({commit}, pagination) {
        commit('setPagination', pagination)
    },
    async transferAuth({state, commit, dispatch})  {
        const userInfo = state.userInfo;
        const features = userInfo.features;

        commit('setJustLoggedIn', true);

        var objActivity = {
            action: 'user.login',
            appId: 'cpm-admin',
            view: '',
            tab: '',
            url: window.location.href,
            source: '',
            data: userInfo.login
        };
        dispatch('status/logActivity',objActivity, {root: true});

        if (features) {
            const modulesDictionary = buildMembershipDictionary(features);
            commit('setModulesDictionary', modulesDictionary);
        }

        let ccoOrgResponse = await UserService.getCcoOrg();
        if (ccoOrgResponse.status === 200)  {
            commit('setCcoOrg', ccoOrgResponse.data);
        }

        let ccoUsersResponse = await UserService.getCcoUsers();
        if (ccoUsersResponse.status === 200) {
            commit('setCcoUsers', ccoUsersResponse.data);
        }

        dispatch('status/setStatus', {inProgress: false, operation: "Login", success: true, logAction: 'login'}, {root: true});

        return true;
    },
    async getOrganizations({commit, rootGetters, state}) {
        try {
            let response = await UserService.getOrganizations()
            commit('setOrganizations', response.data)
        } catch (ex) {
            console.error(ex)
            return
        }
    },
    async setOrganizationContext({state, commit}, orgId) {

        var org = _.find(state.organizations, {id: orgId})

        commit('setOrgContext', orgId)
        commit('setOrgContextTimezone', org.timeZone)
    },
    async getAllUsers({commit, rootGetters, state}) {
        try {
            let response = await UserService.getUsers(false)
            commit('setUsers', response.data)
        } catch (ex) {
            console.error(ex)
            // Handle error
            return
        }
    },
    async loadUsersIfNotLoaded({state, dispatch}) {
        if (state.users && state.users.length) {
            return
        }
        return dispatch('getAllUsers')
    },
    async addOrUpdateUser({commit, rootGetters, state, dispatch}, user) {
        try {

            if (user.id === -1) {
                delete user.id
            }
            if (!user.org) {
                user.org = {id: rootGetters['user/getOrgContext'] || rootGetters['user/getOrgId']}
            }

            if (user.id && !user.collectionAgent) {

                await dispatch('systems/loadSystemsIfNotLoaded', {}, {root: true})

                if (rootGetters['systems/hasSystemsAssignedToCa'](user.id)) {
                    alert('This user has infrastructure assigned to it. Please remove those associations before this change.')
                    return false
                }
            }

            let response = await UserService.addOrUpdateUser(user)

            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "User updated", success: true, logAction: 'updating-user'}, {root: true})
                user.olv = response.data.olv
                dispatch('getAllUsers')
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error updating user", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-updating-user'}, {root: true})
                return false
            }

        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving user", failure: true, message: Common.getErrorMessage(ex, 409, 'Login may already be in use. Please try again.'), logAction: 'error-updating-user'}, {root: true})
            alert('Error saving user ' + Common.getErrorMessage(ex, 409, 'Login may already be in use. Please try again.'))
            return false
        }
    },
    async deleteUser({commit, rootGetters, state, dispatch}, user) {
        try {
            if (user.collectionAgent) {

                await dispatch('systems/loadSystemsIfNotLoaded', {}, {root: true})

                if (rootGetters['systems/hasSystemsAssignedToCa'](user.id)) {
                    alert('This user has infrastructure assigned to it. Please remove those associations before this change.')
                    return false
                }
            }

            let response = await UserService.deleteUser(user.id)

            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "User deleted", success: true, logAction: 'deleting-user'}, {root: true})
                dispatch('getAllUsers')
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error deleting user", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-deleting-user'}, {root: true})
                return false
            }

        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error deleting user", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-deleting-user'}, {root: true})
            alert('Error deleting user ' + Common.getErrorMessage(ex))
            return false
        }
    },
    async changePassword({dispatch}, {user, newLogin, newPassword, sendPwdEmail}) {
        try {
            const patch = { login: newLogin, password: newPassword, sendPwdEmail }

            let response = await UserService.changePassword(user.id, patch)

            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "User updated", success: true, logAction: 'changing-password'}, {root: true})
                user.olv = response.data.olv
                dispatch('getAllUsers')
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error updating user", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-changing-password'}, {root: true})
                return false
            }
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving user", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-changing-password'}, {root: true})
            if (ex.response.status === 409) {
                alert('The login name may already be in use')
            } else {
                alert('Error saving user ' + Common.getErrorMessage(ex))
            }
            return false
        }
    },
    updateOrgSelectionLock({commit}, value) {
        commit('setOrgSelectionLock', value)
    },
    async getUserPrivilegesAndCustomRoles({commit, rootGetters}) {
        try {
            let response1 = await UserService.getUserPrivileges()
            let response2 = await UserService.getOrgCustomRoles()

            let roles = _.concat(response1.data, response2.data)

            commit('setUserPrivilegesAndCustomRoles', roles)
        } catch (ex) {
            console.error(ex)
            // Handle error
            return
        }
    },
    async getAppConfigs({commit}) {
        try {
            let response = await OrgService.getAppConfigs()
            commit('setAppConfigs', response.data)
        } catch (ex) {
            console.error(ex)
        }
    },
    async updateAppConfig({commit}, appConfig) {
        try {
            // console.log('updating')
            let response = await OrgService.updateAppConfig(appConfig)
            if (response.status === 200) {
                commit('updateAppConfig', response.data)
            }
        } catch (ex) {
            console.error(ex)
        }
    },
    setJustLoggedIn({commit}, value) {
        commit('setJustLoggedIn', value);
    },
    async buildModuleURL({}, {userId, login, module}) {
        let response = await UserService.getToken(userId);
        if ((response.status === 200) && (response.data)) {
            let baseUrl = window.location.href.split(/\/?[?#]/)[0]
            return baseUrl + "/#/login/" + response.data + "/" + login + "/url/" + module
        }
        return null
    },
    async getDeletedUsers() {
        let response = await UserService.getUsers(true)
        return response.data
    },
    async unDeleteUser({}, userId) {
        let response = await UserService.unDeleteUser(userId)
        return response.status === 200
    },
    async unDeleteMultipleUsers({}, users) {
        const patchlist = _.map(users, (user) => { return {id: user.id, deleted: false}})
        let response = await UserService.patchMultiple(patchlist)
        return response.status === 200
    }
}

function buildMembershipDictionary(membershipArray) {
    // parse membership string, remove empty values and duplicates
    var membershipList = _.chain(membershipArray).without('').uniq().value();
    var dictionary = {};
    _.forEach(membershipList, function (item) {
        dictionary[item] = true; // mark each item on the list as available on the dictionary
    });
    return dictionary;
}

function buildMiscData(miscDataStr) {
    var result = {}
    var tokens = miscDataStr.split(';')
    for (var i=0; i<tokens.length; i++) {
        if (tokens[i] && tokens[i].includes('=')) {
            var tokens2 = tokens[i].split('=')
            result[tokens2[0]] = tokens2[1]
        }
    }
    return result
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
